import instance from '../api'

export const fetchCurrentUser = async () => {
  const { data } = await instance.get(`/users/usuario_logado`)
  return data
}

export const fetchTokenRedeBasica = async () => {
  const { data } = await instance.get(`/users/token_rede_basica`)
  return data
}

export const fetchTokenEngecomp = async () => {
  const { data } = await instance.get(`/users/token_engecomp`)
  return data
}

export const fetchUserByEmail = async (params = {}) => {
  const { data } = await instance.get(`/users/user_by_email`, { params })
  return data
}

export const fetchUserLogins = async id => {
  if(!id) return {}

  const { data } = await instance.get(`/users/${id}/user_logins`)
  return data
}

export const fetchUserAcessos = async (id, params = {}) => {
  if(!id) return {}

  const { data } = await instance.get(`/users/${id}/user_acessos`, { params })
  return data
}

export const fetchUserAcessosPorDia = async (id, params = {}) => {
  if(!id) return []

  const { data } = await instance.get(`/users/${id}/user_acessos_por_dia`, { params })
  return data
}

export const fetchUserAnalytics = async id => {
  if(!id) return {}

  const { data } = await instance.get(`/users/${id}/user_analytics`)
  return data
}

export const fetchUsersAnalyticsGeral = async (params = {}) => {
  const { data } = await instance.get(`/users/analytics_geral`, { params })
  return data
}

export const fetchUserRoles = async () => {
  const { data } = await instance.get(`/users/user_roles`)
  return data
}

export const fetchUsers = async (params = {}) => {
  const { data } = await instance.get(`/users`, { params })
  return data
}
